package one.healthium.insights.domain.models

data class ContentPreviewModel(
    val title: String?,
    val description: String?,
    val thumbUrl: String?,
)
